import React from 'react';
import { BookOpen } from 'lucide-react';
export function Journal() {
  return <div className="p-8 max-w-7xl mx-auto flex flex-col items-center justify-center min-h-[60vh] text-center" data-id="element-237">
      <div className="w-20 h-20 bg-purple-50 rounded-full flex items-center justify-center mb-6" data-id="element-238">
        <BookOpen className="w-10 h-10 text-purple-500" data-id="element-239" />
      </div>
      <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-240">
        Your Wellness Journal
      </h1>
      <p className="text-slate-500 max-w-md" data-id="element-241">
        Track your mood, symptoms, and daily thoughts here.
      </p>
      <button className="mt-8 bg-slate-800 hover:bg-slate-900 text-white px-6 py-3 rounded-xl font-medium transition-colors" data-id="element-242">
        Write First Entry
      </button>
    </div>;
}